var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconOutdoors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 28.2873C34.0205 27.6638 32.6591 26.132 31.5331 24.4283C30.8275 23.3607 29.2757 23.4256 28.5091 24.4503C26.7567 26.793 24.1406 28.6667 19.9999 28.6667C15.8223 28.6667 13.1967 26.2826 11.4441 24.0392C10.7119 23.102 9.31021 23.1145 8.66938 24.1164C7.50123 25.9427 6.13996 27.626 3.33325 28.2873",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 36.6207C34.0205 35.9971 32.6591 34.4653 31.5331 32.7617C30.8275 31.6941 29.2757 31.759 28.5091 32.7837C26.7567 35.1263 24.1406 37 19.9999 37C15.8223 37 13.1967 34.616 11.4441 32.3726C10.7119 31.4354 9.31021 31.4479 8.66938 32.4497C7.50123 34.276 6.13996 35.9593 3.33325 36.6207",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4523 7.6343L30.4346 5.10484C30.426 3.86735 29.4661 2.84512 28.2316 2.7588C26.8689 2.66351 25.7083 3.73777 25.6982 5.10381L25.5771 21.4754",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4549 7.6343L19.4373 5.10484C19.4287 3.86735 18.4688 2.84512 17.2343 2.7588C15.8715 2.66351 14.711 3.73777 14.7009 5.10381L14.5798 21.4754",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.5503L17 12.5503",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.5503L17 17.5503",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconOutdoors);
export default __webpack_public_path__ + "static/media/Home-Icon-Outdoors.bcc31d88a74bda9e73b52526f66b5b1c.svg";
export { ForwardRef as ReactComponent };